import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { CompactEditButton, DefinitionList, SectionCard } from '../../../design-system';
import type { StaffingPlanInput } from '../operations/planModel';
import { formatDateOnly } from '../model/staffingPagePresentation';

/** 변경 내역 작성과 제출 검토가 같은 기본 정보와 수정 진입점을 사용합니다. */
export function StaffingPlanBasicInfo({ plan, onEdit, editDisabled = false, showReason = true }: {
  plan: Pick<StaffingPlanInput, 'title' | 'effectiveDate' | 'reason'>;
  onEdit?: () => void;
  editDisabled?: boolean;
  showReason?: boolean;
}) {
  return <SectionCard title="기본 정보" showDivider={false} action={onEdit && <CompactEditButton aria-label="기본 정보 수정" disabled={editDisabled} onClick={onEdit}>수정</CompactEditButton>}>
    <Box sx={{ px: 2, pb: 2 }}>
      <DefinitionList items={[
        ['발령안 제목', <Box sx={{ overflowWrap: 'anywhere' }}>{plan.title}</Box>],
        ['시행일', formatDateOnly(plan.effectiveDate)],
        ...(showReason ? [['발령 사유', plan.reason.trim() ? <Box sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{plan.reason}</Box>
          : <Typography component="span" variant="body2" color="text.secondary">미입력 · 요청 전 입력 필요</Typography>] as [string, ReactNode]] : []),
      ]} />
    </Box>
  </SectionCard>;
}
